import React from "react";
import CustomDropdown from "../../components/customDropdown";
import { getOperatorList } from "./filterUtils";

const FieldDropdownComponent = ({
  item,
  idx,
  handleChange,
  filterColumns,
  originalFilterColumns,
  operatorList,
  onFieldSpecificAction,
  wrapperRef,
  isReportModule = false,
  disabled = false,
}) => {
  const [filteredColumns, setFilteredColumns] = React.useState(filterColumns);
  const mountedRef = React.useRef(true);

  // Prevent memory leaks
  React.useEffect(() => {
    return () => {
      mountedRef.current = false;
    };
  }, []);

  // Fix selectedValue - search everywhere
  const selectedValue = React.useMemo(() => {
    const field = item?.value?.field || item?.field || item.inputValue?.field;
    if (!field) return null;
    return (
      filteredColumns.find((fc) => fc.field === field) ||
      filterColumns.find((fc) => fc.field === field) ||
      originalFilterColumns?.find((fc) => fc.field === field) ||
      null
    );
  }, [filteredColumns, filterColumns, originalFilterColumns, item?.value?.field]);

  const onClose = () => {
    if (mountedRef.current) setFilteredColumns(filterColumns);
  };

  const onOpen = () => {
    if (mountedRef.current) setFilteredColumns(filterColumns);
  };

  React.useEffect(() => {
    if (mountedRef.current) setFilteredColumns(filterColumns);
  }, [filterColumns]);

  const handleDropDownChange = (e) => {
    const value = e;
    const selectedItem = filterColumns.find((fc) => fc.field === value.field);

    if (item.value?.field !== value.field) {
      const allowed = getOperatorList(value?.type, operatorList, selectedItem);
      const defaultOp = selectedItem?.defaultOperator
        ? allowed.find((x) => x.operator_value === selectedItem.defaultOperator)
        : null;
      handleChange(
        { ...item, value: selectedItem, operator: defaultOp || allowed?.[0] || {} },
        idx
      );
      onFieldSpecificAction?.(value?.field, value?.dropDownControl);
    }
  };

  return (
    <CustomDropdown
      data={filteredColumns}
      style={{ width: "180px", marginTop: "20px" }}
      textField="title"
      dataItemKey="field"
      onOpen={onOpen}
      valueData={selectedValue}
      onChange={handleDropDownChange}
      filterable={true}
      onFilterChange={setFilteredColumns}
      autoClose={false}
      autoBind={true}
      isSelectALl={true}
      dataList={isReportModule ? filterColumns : originalFilterColumns}
      onClose={onClose}
      disabled={disabled}
    />
  );
};

export default FieldDropdownComponent;
